// src/components/auth/AuthTemplate.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../common/Footer";
import { AuthBackground } from "../common/AuthBackground";
import "./AuthLayout.css";

const AuthLayout = () => {
  return (
    <div className="login-container">
      <AuthBackground>
        {/* background-pattern is handled by your CSS */}

        <div className="login-form-area">
          <div className="logo">
            <img src="/assets/SidebarLogoImage.svg" alt="Logo" />
          </div>

          {/* render the form for whichever sub‐route we’re on */}
          <Outlet />
        </div>

        <Footer />
      </AuthBackground>
    </div>
  );
};

export default AuthLayout;
